
document.addEventListener("turbolinks:load", () => {  // iwan
  $('table.table-rupes.table-clickable-rows td:not(.not-clickable)').on('click', function() {
    var url = $(this).parent().data('url');
    if (url!='') {
      if ($(this).parent().data('remote')==true) {
        $.get({url: url, dataType: 'script'});
      } else {
        Turbolinks.visit(url);
      }
    }
  });



  if($('[id^=DataTables_Table]').length == 0) {
    $('.datatable').DataTable({
      "pageLength": 100,
      "autoWidth": false
    });

    $('.datatable-not-sortable').DataTable({
      "ordering": false,
      "autoWidth": false,
      "pageLength": 100
    })
  }

});
